module.exports = __webpack_public_path__ + "img/img(10).01376b04.png";